<template>
  <div :class="bgColor" @click="nav" @mouseenter="focus" @mouseleave="blur" class="p-3 md:p-6 w-full md:w-1/2 border-b border-gray-400 border-card flex flex-col transition-colors duration-150 cursor-pointer">
    <div class="max-w-sm">
      <p class="mb-1">{{ author }}</p>
      <h3 v-html="post.title.rendered" class="text-2xl font-bold leading-tight"></h3>
    </div>
    <div class="mt-5 max-w-sm flex-auto">
      <div v-html="post.excerpt.rendered" class="font-thin my-2 clamp-3 overflow-hidden"></div>
    </div>
    <div @click.stop class="mt-5 flex justify-between items-center">
      <div class="relative">
        <circles-svg :class="{ 'opacity-0': hovering }" class="transition-all duration-150"/>

        <ul :class="{ 'opacity-0': !hovering }" class="absolute left-0 abs-top transition-all duration-100 whitespace-no-wrap">
          <li v-for="tax in sammlung" :key="tax.id" :class="`text-${tax.slug}`" class="lowercase commas text-sm inline-block">
            <anchor-wrap :url="tax.link">{{ tax.name }}</anchor-wrap>
          </li>
        </ul>
      </div>

      <div class="flex-none">
        <router-link :to="postLink" :class="txtColor">
          <svg class="inline-block" width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M11 11v-11h1v11h11v1h-11v11h-1v-11h-11v-1h11z" fill="currentColor"/></svg>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import AnchorWrap from '@/components/AnchorWrap'
  import CirclesSvg from '@/components/CirclesSvg'
  import { relativeUrl } from '@/utils'

  export default {
    name: 'PostCard',
    props: {
      post: Object
    },
    data () {
      return {
        hovering: false
      }
    },
    computed: {
      sammlung () {
        if (!this.post) return []
        return this.post._embedded['wp:term'].reduce((a, c) => {
          return a.concat(...c.filter(t => t.taxonomy === 'category'))
        }, [])
      },
      sammlungList () {
        return this.sammlung.filter(t => t.slug !== 'allgemein')
      },
      txtColor () {
        const c = this.sammlung[0]
        if (!c) return
        return `text-${c.slug}`
      },
      bgColor () {
        const c = this.sammlung[0]
        if (!c) return
        return `hover:bg-${c.slug}`
      },
      author () {
        if (!this.post) return {}
        return this.post.acf.autor || this.post._embedded.author[0]?.name
      },
      postLink () {
        return relativeUrl(this.post?.link)
      }
    },
    methods: {
      nav () {
        if (this.$route.fullPath !== this.postLink) {
          this.$router.push(this.postLink)
        }
      },
      focus () {
        this.hovering = true
      },
      blur () {
        this.hovering = false
      }
    },
    components: { AnchorWrap, CirclesSvg }
  }
</script>
